import { render, staticRenderFns } from "./ArchivoNewOrEdit.vue?vue&type=template&id=90f2fcda&scoped=true&"
import script from "./ArchivoNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ArchivoNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArchivoNewOrEdit.vue?vue&type=style&index=0&id=90f2fcda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f2fcda",
  null
  
)

export default component.exports